import { SkillCertShortDto } from 'src/types/skill';

export enum CertScrollAnchors {
    Questions = 'anchor-questions',
}

export interface CertPageState {
    shortSkills: SkillCertShortDto[];
}
